import lscache from 'lscache'

class FeatureManager {
  // for now these should be one word only as they are used as ids/keys
  static ALLFEATURES = ['login']

  static setFeature = (feature, value) => {
    (typeof window !== 'undefined') && lscache.set(`feature_${feature}`, value)
  }

  static getFeature = (feature) => {
    return (typeof window !== 'undefined') && lscache.get(`feature_${feature}`) === true
  }
}

export default FeatureManager



// WEBPACK FOOTER //
// ./assets/js/lib/FeatureManager.js